module.exports = __webpack_public_path__ + "img/organization-info.283b0b12.svg";